import type { SVGProps } from 'react';

const SvgFavoriteCollections = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 11c.55 0 1-.45 1-1s-.45-1-1-1H5V6c0-.55.45-1 1-1h3c.7 0 1.28.39 1.95.83C11.77 6.38 12.7 7 14 7h4c.55 0 1 .45 1 1v1c0 .55.45 1 1 1s1-.45 1-1V8c0-1.65-1.35-3-3-3h-4c-.7 0-1.28-.39-1.95-.83C11.23 3.62 10.3 3 9 3H6C4.35 3 3 4.35 3 6v10c0 1.65 1.35 3 3 3h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-5z"
    />
    <path
      fill="currentcolor"
      d="M20.51 12.44c-.9-.63-2.08-.78-3.15-.39q-.6.21-1.05.6-.465-.39-1.05-.6c-1.08-.39-2.25-.24-3.15.39-.85.6-1.39 1.52-1.48 2.54s.28 2.02 1 2.75L14.9 21c.39.39.9.58 1.41.58s1.02-.2 1.41-.58l3.27-3.27c.72-.73 1.09-1.73 1-2.75a3.5 3.5 0 0 0-1.48-2.55z"
    />
  </svg>
);
export default SvgFavoriteCollections;
